import * as FullStory from "@fullstory/browser";
import admins from "../../services/admins";

export const init = () => {
    if (process.env.ENVIRONMENT_NAME === "prod") {
        FullStory.init({ orgId: "17JWPP" });
    }
};

export const identify = (jwt, user) => {
    const isDelegatedAccess =
        user && jwt && user.id !== jwt.sub && admins.find((admin) => admin.userId === jwt.sub);

    if (process.env.ENVIRONMENT_NAME !== "prod") return;
    let displayName;
    if (user && user.name && (user.name.familyName || user.name.givenName)) {
        displayName = `${user.name.givenName} ${user.name.familyName}`;
    }
    if (isDelegatedAccess) {
        FullStory.identify(jwt.sub);
    } else {
        FullStory.identify(jwt.sub, {
            displayName: user.displayName || displayName,
            email: user.emails[0],
            pricingPlan_str:
                user.plans &&
                user.plans.length > 0 &&
                user.plans.map((plan) => plan.name).join("_"),
        });
    }
};

export const setUserVars = (userVars) => FullStory.setUserVars(userVars);
